import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCurrentUser } from 'client/features/users/actions'
import UserFrom from './UserForm.jsx'
import { UsersRequest } from 'client/features/users/actions'

class User extends Component {
    constructor(props) {
        super(props)
        this.submitUser = this.submitUser.bind(this)
        this.sendInvitation = this.sendInvitation.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(setCurrentUser(this.props.params.id))
    }

    componentDidUpdate() {
        if (this.props.user && this.props.user !== this.props.params.id) {
            this.props.dispatch(setCurrentUser(null))
            setTimeout(() => {
                this.props.dispatch(setCurrentUser(this.props.params.id))
            }, 10)
            this.forceUpdate()
        } 
    }

    submitUser(payload, dispatch) {
        if (!payload.new)
            dispatch(UsersRequest.put.action({ payload, params: this.props.params }))
        else
            dispatch(UsersRequest.post.action({ payload }))
    }

    sendInvitation() {
        this.props.dispatch(UsersRequest.put.action({ payload: { invite: true }, params: this.props.params }))
    }

    render() {
        let user = this.props.users.all.find(user => user._id === this.props.user) || {}
        if (this.props.params.id === 'new')
            user = { new: true }
        return (
            <div className='card-box'>
                <UserFrom
                    initialValues={ { ...user } }
                    user={ user }
                    name={ `user-${this.props.user}` }
                    onSubmit={ this.submitUser }
                    sendInvitation={ this.sendInvitation }
                />
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { session, users } = state
    return { user: users.current, users }
}

export default connect(mapStateToProps)(User)


// WEBPACK FOOTER //
// ./src/client/features/users/containers/User.jsx